import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Diet = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="m14.27 12.15-.86.85 7.07 7.07-1.4 1.41L12 14.41l-7.07 7.07-1.41-1.4 9.33-9.35c-.58-1.46.02-3.55 1.62-5.16 1.96-1.95 4.65-2.42 6.01-1.06 1.37 1.37.9 4.06-1.05 6.02-1.6 1.6-3.7 2.2-5.16 1.62ZM4.22 3.8l6.72 6.71-2.83 2.83-3.89-3.89a4 4 0 0 1 0-5.65Zm13.79 5.3c1.26-1.26 1.52-2.73 1.06-3.18-.46-.46-1.92-.2-3.18 1.06-1.26 1.26-1.52 2.72-1.06 3.18.45.46 1.92.2 3.18-1.06Z"
    />
  </svg>
));
